import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../index";
const { REACT_APP_API_URL } = process.env;

interface ISupportData {
    answer: string;
    created_at: string;
    id: string;
    question: string;
    type: string;
    updated_at: string;
}
interface ISupport {
    buyer: Array<ISupportData>;
    seller: Array<ISupportData>;
}

export interface IFormData {
    name: string;
    email: string;
    question: string;
}

export const supportApi = createApi({
  reducerPath: "supportApi",
  tagTypes: ['Support'],
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const token = state.auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getFaqsList: builder.query<ISupport, void>({
      query: () => ({
        url: "/api/faqs",
        method: "GET",
      }),
      providesTags: ["Support"],
    }),
    addQuestion: builder.mutation({
        query: (formData: IFormData) => ({
          url: `/api/support-cases`,
          method: 'POST',
          body: formData,
        }),
        invalidatesTags: ['Support'],
      }),
  }),
});

export const { useGetFaqsListQuery, useAddQuestionMutation } = supportApi;
